import React, { useState } from "react"
import PropTypes from "prop-types"
import Webform from "gatsby-drupal-webform"
import { navigate } from "gatsby"
import Layout from "../components/Layout/layout"
import SEO from "../components/seo"
import {
  contactContainer,
  contactFormContainer,
  contactFormTitle,
  inputHoney,
} from "../styles/contactez-nous.module.scss"
import "../styles/contact-form.scss"
import { ContactezNousImage, Title } from "../styled-components/contact-styled"
import Ariane from "../components/Ariane/ariane"
import { useWebform } from "../hooks/use-webform"

const CustomSubmit = () => {
  return (
    <button className="btn" type="submit">
      Envoyer le formulaire
    </button>
  )
}

const ContactForm = ({ arianeDisplayed }) => {
  const [honeyValue, setHoneyValue] = useState(false) // HoneyPot state -> Allow to remove webform if bot complete first form input (which is first in HTML)
  const data = useWebform()
  return (
    <Layout message="Formulaire de contact">
      <SEO title="Formulaire de contact" />
      {arianeDisplayed && (
        <Ariane pageName="Formulaire de contact" isListing={true} />
      )}
      <form id="my_contactform" action="/mycontactform">
        <label className={inputHoney} htmlFor="subject">
          <input
            onChange={(element) => setHoneyValue(element.target.value)}
            className={inputHoney}
            autoComplete="off"
            type="text"
            id="subject"
            name="subject"
            placeholder="Your subject here"
          />
        </label>
      </form>
      <div className={contactContainer}>
        <div className={contactFormContainer}>
          <Title className={contactFormTitle}>Contactez nous !</Title>
          {!honeyValue && (
            <Webform
              webform={data.webformWebform}
              buttonComponent={CustomSubmit}
              endpoint={`${process.env.GATSBYSIDE_DRUPAL_URL}/react_webform_backend/submit`}
              onSuccess={() => {
                navigate("/contact-confirmation", {
                  state: { formValidation: true },
                })
              }}
              onError={() => {
                navigate("/contact-confirmation", {
                  state: { formValidation: false },
                })
              }}
            />
          )}
        </div>
        <ContactezNousImage />
      </div>
    </Layout>
  )
}

ContactForm.propTypes = {
  arianeDisplayed: PropTypes.bool,
}

export default ContactForm
